import React from "react";

const Chapters = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11317_15201)">
        <path
          d="M14.7 6.60001V9.3H12.9C10.92 9.3 9.29999 10.92 9.29999 12.9V14.7H6.59998C4.61998 14.7 3 13.08 3 11.1V6.60001C3 4.62001 4.61998 3 6.59998 3H11.1C13.08 3 14.7 4.62001 14.7 6.60001Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M17.3998 9.2998H12.8998C10.9116 9.2998 9.2998 10.9116 9.2998 12.8998V17.3998C9.2998 19.388 10.9116 20.9998 12.8998 20.9998H17.3998C19.3881 20.9998 20.9998 19.388 20.9998 17.3998V12.8998C20.9998 10.9116 19.3881 9.2998 17.3998 9.2998Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_11317_15201">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Chapters;
